<template>
  <div id="index">
    <el-container class="layout-shell">
      <div :class="['menu11', {'menu-collapsed': isCollapse}]">
        <button class="menu-toggle" type="button" @click="handleMenu">
          <i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
        </button>
        <el-scrollbar class="menu-scrollbar">
          <el-menu
              v-if="!isCollapse"
              :default-active="home"
              :collapse="false"
              :router="true"
              unique-opened>
            <template v-for="(item, index) in routes">
              <el-submenu
                  v-if="item.children && item.children.length > 0"
                  :index="item.key"
                  v-bind:key="item.value"
                  :class="['menu-root', 'menu-tone-' + (index % 6)]">
                <template slot="title">
                  <span class="root-title">
                    <span class="menu-mark">{{getMenuMark(item.name, index)}}</span>
                    <span class="menu-title">{{item.name}}</span>
                  </span>
                </template>
                <el-submenu
                    v-for="item_2 in item.children"
                    v-if="item_2.children && item_2.children.length > 0"
                    :index="item_2.key"
                    v-bind:key="item_2.value"
                    class="menu-branch">
                  <template slot="title">
                    <span class="branch-title-wrap">
                      <span class="branch-line"></span>
                      <span class="branch-title">{{item_2.name}}</span>
                    </span>
                  </template>
                  <el-menu-item
                      v-for="item_3 in item_2.children"
                      :index="item_3.path"
                      v-bind:key="item_3.value"
                      class="menu-leaf">
                    <span slot="title" class="leaf-title">
                      <span class="leaf-line"></span>
                      <span class="select-label">{{item_3.name}}</span>
                    </span>
                  </el-menu-item>
                </el-submenu>
                <el-menu-item
                    v-else
                    :index="item_2.path"
                    v-bind:key="item_2.value"
                    class="menu-leaf">
                  <span slot="title" class="leaf-title">
                    <span class="leaf-line"></span>
                    <span class="select-label">{{item_2.name}}</span>
                  </span>
                </el-menu-item>
              </el-submenu>
              <el-menu-item
                  v-else
                  :index="item.path"
                  v-bind:key="item.value"
                  :class="['menu-root', 'menu-root-single', 'menu-tone-' + (index % 6)]">
                <span slot="title" class="root-single-title">
                  <span class="menu-mark">{{getMenuMark(item.name, index)}}</span>
                  <span class="menu-title">{{item.name}}</span>
                </span>
              </el-menu-item>
            </template>
          </el-menu>
          <div v-else class="collapsed-menu-list">
            <div
                v-for="(item, index) in routes"
                :key="item.value"
                :class="['collapsed-menu-root', 'menu-tone-' + (index % 6)]"
                @mouseenter="showCollapsedFlyout(item, $event)"
                @mouseleave="scheduleHideCollapsedFlyout">
              <button
                  type="button"
                  class="collapsed-root-button"
                  @click="!item.children || item.children.length === 0 ? handleCollapsedFlyoutSelect(item.path) : null">
                <span class="menu-mark">{{getMenuMark(item.name, index)}}</span>
              </button>
            </div>
          </div>
        </el-scrollbar>
        <div
            v-if="isCollapse && collapsedFlyoutMenu && collapsedFlyoutMenu.children && collapsedFlyoutMenu.children.length > 0"
            class="collapsed-flyout"
            :style="{top: collapsedFlyoutTop + 'px'}"
            @mouseenter="cancelHideCollapsedFlyout"
            @mouseleave="scheduleHideCollapsedFlyout">
          <div class="flyout-title">{{collapsedFlyoutMenu.name}}</div>
          <template v-for="item_2 in collapsedFlyoutMenu.children">
            <div
                v-if="item_2.children && item_2.children.length > 0"
                :key="item_2.value"
                class="flyout-group">
              <div class="flyout-group-title">{{item_2.name}}</div>
              <a
                  v-for="item_3 in item_2.children"
                  :key="item_3.value"
                  href="javascript:void(0);"
                  class="flyout-link"
                  @click.stop="handleCollapsedFlyoutSelect(item_3.path)">
                {{item_3.name}}
              </a>
            </div>
            <a
                v-else
                :key="item_2.value"
                href="javascript:void(0);"
                class="flyout-link"
                @click.stop="handleCollapsedFlyoutSelect(item_2.path)">
              {{item_2.name}}
            </a>
          </template>
        </div>
      </div>
      <el-container>

        <el-header class="header">
          <div class="header-brand">
            <a href="javascript:void(0);" class="platform-title">{{platfromName.platfromName}}</a>
            <div class="header-date">
              <span>当前日期</span>
              <strong>{{date}}</strong>
            </div>
          </div>

          <div class="header-actions">
            <button class="big-screen-button" type="button" @click="showBigReport" value="显示子窗体">
              <i class="el-icon-s-data"></i>
            </button>
            <div class="expiration-card">
              <span>系统到期时间</span>
              <strong>{{expirationFrom.expirationDate || '-'}}</strong>
            </div>
            <div class="header-menu">
              <img :src="loginUser.icon" class="user-avatar"/>
              <el-dropdown trigger="click" @command="handleUserCommand">
                <span class="el-dropdown-link user-name">
                  {{loginUser.name}}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="user-info">个人信息</el-dropdown-item>
                  <el-dropdown-item command="logout" divided>退出</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <!-- 新增测试告警按钮 -->
<!--          <div class="header-logo logo">-->
<!--            <el-button type="warning" icon="el-icon-bell" @click="testAlarmDialog">开启</el-button>-->
<!--          </div>-->


        </el-header>
        <el-main class="page-main" :style="{'height':minPageHeight+'px'}" style="overflow: hidden;">

          <div id="main-box">
            <div :style="{'height':(minPageHeight - 10)+'px'}"  >
              <el-scrollbar style="height: 100%">
                <div id="content-pane" style="padding-right: 10px">
                  <router-view />
                </div>
              </el-scrollbar>
            </div>
          </div>


        </el-main>
      </el-container>
    </el-container>

    <el-dialog
        :title="callingDialog.title"
        :visible.sync="callingDialog.visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false" top="7vh"
        width="90%">
      <div id="skill_index_page" style=";"></div>
    </el-dialog>

    <el-dialog
        :title="eventDialog.title"
        :visible.sync="eventDialog.visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false" top="7vh"
        width="90%">
      <div id="event_index_page" style=""></div>
    </el-dialog>

    <el-dialog
        title="视频通话"
        v-if="zegoDialog.visible"
        :visible.sync="zegoDialog.visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false" top="7vh"
        width="60%">
      <div class="zego-contains">
        <div id="remote-container" class="remote-container"></div>
        <div id="local-container" class="local-container"></div>
        <el-button class="call-end-btn"
                   @click="stopVideo"
                   type="danger" icon="el-icon-phone" circle></el-button>
      </div>
    </el-dialog>

    <el-dialog v-dialogDrag title="" :visible.sync="eventDialog1" width="60%" custom-class="customClass">
      <el-row >

        <el-col :span="24">
          <el-row >
            <el-col :span="24" style="height: 475px;padding-left: 60px;">
              <ul style="list-style:none;padding-top: -200px">
                <li>
                  <img src="../static/asert/tankuang/aa.gif" style="width: 164px;margin-left:41%;height: 164px"/>
                </li>
                <li style="color: #333333;font-size: 30px;font-weight: bold;text-align:center;margin-bottom: 25px;">{{eventNew.behaviorException}}</li>
                <li style="color:#f94033;font-size: 24px;margin-top: 10px;padding-left: 70px">{{eventNew.content}}</li>
                <li v-if="showAgedAlarmInfo" style="margin-top: 25px">
                  <a style="padding-left: 70px;">
                    <img src="../static/asert/tankuang/icon1.1@2x.png" style="width: 25px;height: 25px;padding-top: 10px;"/>
                  </a>
                  <a style="color:#999999;font-size: 20px;padding-left: 20px;text-align: center">告警老人姓名:</a>
                  <a style="color:#333333;font-size: 25px;font-weight: bold;">{{eventNew.agedName}}</a>
                </li>
                <li v-if="showAgedAlarmInfo" style="margin-top: 25px">
                  <a style="padding-left: 70px;">
                    <img src="../static/asert/tankuang/icon1.2@2x.png" style="width: 25px;height: 25px;padding-top: 10px;"/>
                  </a>
                  <a style="color:#999999;font-size: 20px;margin-top: 10px;padding-left: 20px">告警老人电话:</a>
                  <a style="color:#333333;font-size: 25px;font-weight: bold;margin-top: 10px">{{eventNew.phone}}</a>
                </li>
                <li v-if="showAgedAlarmInfo" style="margin-top: 25px">
                  <a style="padding-left: 70px;">
                    <img src="../static/asert/tankuang/icon1.3@2x.png" style="width: 25px;height: 25px;padding-top: 10px;"/>
                  </a>
                  <a style="color:#999999;font-size: 20px;margin-top: 10px;padding-left: 20px">告警老人地址:</a>
                  <a style="color:#333333;font-size: 25px;font-weight: bold;margin-top: 10px">{{eventNew.location}}</a>
                </li>
              </ul>
            </el-col>
          </el-row>

        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
                <el-button round @click="eventDialog1 = false">关 闭</el-button>
        </span>
    </el-dialog>



    <el-dialog v-dialogDrag title="" :visible.sync="eventDialog2" width="60%" custom-class="customClass">
      <el-row >
        <el-col :span="24">
          <el-row >
            <el-col :span="24" style="height: 475px;padding-left: 60px;">
              <ul style="list-style:none;padding-top: -200px">
                <li>
                  <img src="../static/asert/tankuang/aa.gif" style="width: 164px;margin-left:41%;height: 164px"/>
                </li>
                <li style="color: #333333;font-size: 30px;font-weight: bold;text-align:center;margin-bottom: 25px;">{{sleepRadarData.behaviorException}}</li>
                <li style="color:#f94033;font-size: 24px;margin-top: 10px;padding-left: 70px">{{sleepRadarData.content}}</li>
                <li v-if="showAgedAlarmInfo2" style="margin-top: 25px">
                  <a style="padding-left: 70px;">
                    <img src="../static/asert/tankuang/icon1.1@2x.png" style="width: 25px;height: 25px;padding-top: 10px;"/>
                  </a>
                  <a style="color:#999999;font-size: 20px;padding-left: 20px;text-align: center">告警老人姓名:</a>
                  <a style="color:#333333;font-size: 25px;font-weight: bold;">{{sleepRadarData.agedName}}</a>
                </li>
                <li v-if="showAgedAlarmInfo2" style="margin-top: 25px">
                  <a style="padding-left: 70px;">
                    <img src="../static/asert/tankuang/icon1.2@2x.png" style="width: 25px;height: 25px;padding-top: 10px;"/>
                  </a>
                  <a style="color:#999999;font-size: 20px;margin-top: 10px;padding-left: 20px">告警老人电话:</a>
                  <a style="color:#333333;font-size: 25px;font-weight: bold;margin-top: 10px">{{sleepRadarData.phone}}</a>
                </li>
                <li v-if="showAgedAlarmInfo2" style="margin-top: 25px">
                  <a style="padding-left: 70px;">
                    <img src="../static/asert/tankuang/icon1.3@2x.png" style="width: 25px;height: 25px;padding-top: 10px;"/>
                  </a>
                  <a style="color:#999999;font-size: 20px;margin-top: 10px;padding-left: 20px">告警老人地址:</a>
                  <a style="color:#333333;font-size: 25px;font-weight: bold;margin-top: 10px">{{sleepRadarData.location}}</a>
                </li>
              </ul>
            </el-col>
          </el-row>

        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
                <el-button round @click="eventDialog2 = false">关 闭</el-button>
        </span>
    </el-dialog>



    <el-dialog
        title="系统到期提示"
        :visible.sync="expirationFrom.before"
        :modal="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="40%"
    >
      <span style=" color: red ;font-size: 20px;height: 400px"><b>您的系统账户已经到使用截止日期，请及时缴费。</b></span>
      <span slot="footer" class="dialog-footer">
                    <el-button @click="expirationFrom.before = false">关闭</el-button>
                    </span>
    </el-dialog>
  </div>
</template>


<script>

import result from "element-ui/packages/result";

let msg;
let synth;

import {
  getcheckUnHandleEvent,
  gethandleSelect,
  getloadEventNew,
  getLogout,
  getOneBYAgedINDEX,
  initLoginUser, showBigReportINDEX,
  comparisonDeadline
} from '../api/index';
import {initPermissions} from '@/api/index';
import {initSocket} from '@/api/index';
import {UserMessage} from '@/api/index';
import {EdbInfo} from '@/api/index';
import {getUserPlatfromName} from '@/api/index';
import {initMenuDatanew} from '@/api/index';
import $ from 'jquery'
import HomeNew from "@/views/home/home-new";
import {
  initZego,
  startPlayRemote,
  startPlayRemoteStream,
  startPublishLocal,
  stopPlayRemote, stopPublishLocal
} from "@/components/zego/zego-util";
import {sendYangQuanYY} from "@/api/smartScreen/smart_screen";
import {getStationToken} from '@/utils/station-session';



export default {
  name: "index",
  provide: function () {
    return {
      showVideo: this.showVideo
    }
  },
  computed:{
    routes(){
      return this.$store.state.routes;
    },
    showAgedAlarmInfo(){
      return Number(this.eventNew.agedId) !== 0;
    },
    showAgedAlarmInfo2(){
      return Number(this.sleepRadarData.agedId) !== 0;
    }
  },
  data:function (){
    return {
      home:"/home/home-new",
      eventDialog2:false,
      bigData:{
        project:0,
        bigDataName:0,
      },
      expirationFrom:{
        "expirationDate":"",//登录是否过期
        "before":false
      },
      date:new Date().format("yyyy-MM-dd W"),
      lableWidth:"80px",
      icon1:"/static/asert/image/yi-biao-pan.png",
      loginUser:{
        id:"",
        icon:"/static/asert/image/default-head.png",
        name:"",
        type:"",
      },
      nameLeft:'',
      nameRight:'',
      activeIndex: "1",
      isCollapse: false,
      minPageHeight:0,
      activePane: '',
      tabPanes: [],
      menuData:[],
      permissions:[],
      collapsedFlyoutMenu:null,
      collapsedFlyoutTop:76,
      collapsedFlyoutTimer:null,
      dialogVisible:false,
      phoneNum:'',
      callText:'',
      callWaiting:{
        min:0,
        sec:0
      },
      callId:'',
      callNo:'',
      seatNo:'',
      seatStatus:'Local',
      callStatus:'',
      interval:'',
      phoneStatus:1,
      eventDialog: {
        title:'告警',
        visible:false
      },
      zegoDialog: {
        visible:false,
        fromUser:''
      },
      silenceEvents:{},
      callingDialog: {
        title:'用户来电',
        visible:false
      },
      eventDialog1:false,
      eventNew:{
        behaviorException:'',
        content:'',
        phone:'',
        location:'',
        agedName:'',
        agedId:'',
      },
      platfromName:[],
      zg:"",
      /** 睡眠雷达 WebSocket 连接 */
      sleepRadarWebSocket: null,
      /** 睡眠雷达最新推送数据 */
      sleepRadarData: {
        behaviorException:'',
        content:'',
        phone:'',
        location:'',
        agedName:'',
        agedId:'',
      },
      /**语音变量声明*/
      synth:window.speechSynthesis,
      msg:new SpeechSynthesisUtterance()

    }
  },
  mounted:function () {
    let me =this;

    this.getinitLoginUser();
    this.initMenuData();
    this.getPlatfromName();
    this.getComparisonDeadline();
    me.initMinPageHeight();
    window.onresize = function () {
      me.initMinPageHeight();
    };
    me.loadEventNew();
    if(window.speechSynthesis){
      this.synth = window.speechSynthesis;
    }
    if(SpeechSynthesisUtterance){
      this.msg = new SpeechSynthesisUtterance();
    }


  },

  /**语音变量声明*/
  // const:synth = window.speechSynthesis,
  // const1:msg = new SpeechSynthesisUtterance(),


  methods: {
    // 测试告警弹框方法
    testAlarmDialog() {
      this.eventNew = {
        behaviorException: '红外报警器',
        content: '[周权初]红外报警器触发！请及时查看设备，确认安全情况！',
        agedName: '周权初',
        phone: '0760-23216400',
        location: '黄圃镇吴兰村上冲街八巷29号',
        agedId: ''
      };
      this.eventDialog1 = true;
      // 触发语音播报
      this.handleSpeak(this.eventNew.content);
    },

    //语音控制
    openCloseSpeak(){
      let me = this;
      this.synth.cancel();
      this.msg.text = me.eventNew.content;
      this.msg.lang = 'zh-CN';
      this.msg.volume = '1';
      this.msg.rate = 1;
      this.msg.pitch = 1;
      this.synth.speak(this.msg);

    },

    /**语音播报**/
    handleSpeak(e){
      this.msg.text = e;
      this.msg.lang = 'zh-CN';
      this.msg.volume = '1';
      this.msg.rate = 1;
      this.msg.pitch = 1;
      this.synth.speak(this.msg);
    },

    // 查看截止日期是否到期
    getComparisonDeadline() {
      let me = this;
      comparisonDeadline()
          .then(result=>{
            if (result.data) {
              me.expirationFrom=result.data;
            }
          })
    },

    loadEventNew(){
      let me = this;
      getloadEventNew()
          .then(result=>{
            if(result.data){
              me.eventNew = result.data;
              let timestamp = (new Date()).getTime();
              let stringTime = me.eventNew.createTime;
              let timestamp2 = Date.parse(new Date(stringTime));
              me.eventDialog1 = timestamp - timestamp2  <= 60000;
              if(me.eventDialog1){
                me.readText = null;
                me.readText = me.eventNew.content;
                me.handleSpeak(me.eventNew.content);
              }
              if(me.timer){
                clearTimeout(me.timer);
              }
              if (me.eventDialog1){
                //定时刷新
                me.timer = setTimeout(()=>{me.loadEventNew()},60000);
              }else{
                //定时刷新
                me.timer = setTimeout(()=>{me.loadEventNew()},2000);
              }
            }
          })
    },

    getinitLoginUser:function () {
      let me = this;
      initLoginUser()
          .then(result=>{
            if(result && result.data){
              me.loginUser.id = result.data.id;
              if(result.data.icon){
                me.loginUser.icon = "/system-ya/file/image/"+result.data.icon;
              }
              me.loginUser.name = result.data.nickName;
              me.loginUser.type = result.data.type;
              me.getinitPermissions();
              me.getinitSocket();
              me.getUserMessage();
              me.getEdbInfo();
              me.getCurrentUser();
              me.initSleepRadarWebSocket(me.loginUser);
              //初始化视频通话组件
              this.zg = initZego({
                userID:me.loginUser.id+"_EM",
                userName:me.loginUser.name
              },{
                requestAccess:(fromUser)=>{
                  if(this.zegoDialog.visible){
                    this.stopVideo();
                  }
                  this.$nextTick(async () => {
                    this.showVideo(fromUser);
                  })
                },
                endCall:(fromUser)=>{
                  if(this.zegoDialog.visible){
                    this.stopVideo();
                  }
                },
                newStream:(streamList)=>{
                  // 流新增，开始拉流
                  for (let i = 0; i < streamList.length; i++) {
                    const streamID = streamList[i].streamID;
                    const userID = streamID.substring(0,streamID.indexOf("_stream"));
                    if(this.zegoDialog.visible && userID === this.zegoDialog.fromUser.userID){
                      this.$nextTick(async () => {
                        await startPlayRemoteStream("remote-container",streamID);
                      });
                    }
                  }
                },
                removeStream:(streamList)=>{
                  // 流新增，开始拉流
                  for (let i = 0; i < streamList.length; i++) {
                    const streamID = streamList[i].streamID;
                    const userID = streamID.substring(0,streamID.indexOf("_stream"));
                    if(userID === this.zegoDialog.fromUser.userID){
                      this.$nextTick(async () => {
                        stopPlayRemote(this.zegoDialog.fromUser);
                      });
                    }
                  }
                }
              });
            }

          })
    },

    /** 获取当前登录用户信息 */
    getCurrentUser() {
      console.log("ssss",this.loginUser)
      return this.loginUser;
    },

    showVideo(fromUser){
      this.zegoDialog.visible = true;
      this.zegoDialog.fromUser = fromUser;
      this.$nextTick( async ()=>{
        this.zegoDialog.localStream = await startPublishLocal("local-container",this.loginUser.id+"_EM_stream");
        startPlayRemote({
          userID:fromUser.userID
        });
      });
      sendYangQuanYY({
        sn:fromUser.userID,
        callName:this.loginUser.id
      }).then(()=>{
        console.log("通话记录推送成功");
      })
    },
    async stopVideo(){
      stopPlayRemote(this.zegoDialog.fromUser);
      await stopPublishLocal(this.loginUser.id+"_EM_stream",this.zegoDialog.localStream);
      this.zegoDialog.visible = false;
      this.zegoDialog.fromUser = {};
    },

    getOneBYAged:function (id) {
      let me = this;
      getOneBYAgedINDEX(id)
          .then(result=>{
            if(result.data){
              me.eventNew.agedName = result.data.agedName;
              me.eventNew.phone = result.data.phone;
              me.eventNew.location = result.data.location;
            }
          })
    },

    getinitSocket:function () {
      let me = this;
      initSocket()
          .then(result=>{
            if(result && result.data){
              let domain = result.data.domain;
              let channel = result.data.channel;
              let enabled = result.data.enabled;
              if(enabled){
                let socket = io(domain, { 'reconnect': true });
                socket.on('connect', function(){
                  console.log("建立连接");
                  if(me.loginUser.id){
                    socket.emit(channel, {userId:me.loginUser.id});
                  }
                });
                socket.on(channel, function(data){
                  //弹框提示
                  if(data){
                    if(data.agedId !== undefined && data.agedId !== null
                        && (Number(data.agedId) !== 0 || data.behaviorException)){
                      me.eventDialog1 = false;
                      me.eventNew.agedId = data.agedId;
                      me.eventNew.behaviorException = data.behaviorException || data.title || '告警';
                      me.eventNew.content = data.contentNow || data.content;
                      if(Number(data.agedId) !== 0){
                        me.getOneBYAged(data.agedId);
                      } else {
                        me.eventNew.agedName = '';
                        me.eventNew.phone = '';
                        me.eventNew.location = '';
                      }
                      me.eventDialog1 = true;
                      me.openCloseSpeak();
                      if(me.timer){
                        clearTimeout(me.timer);
                      }
                      me.timer = setTimeout(()=>{me.eventDialog1 = false},15000);
                    }
                    if(data.notificationType === 'SILENCE'){
                      me.handleSilenceMsg(data);
                    } else {
                      me.$notify({
                        type: data.notificationType.toLowerCase(),
                        title: data.title,
                        message: data.content,
                        duration:3000,
                        showClose: data.sticky,
                        offset:45
                      });
                    }
                  }
                  me.getUserMessage();
                });
                socket.on('disconnect', function(){
                  console.log("关闭连接");
                });

              }
            }
          })

    },

    initSocket:function () {
      let me = this;
      $.ajax({
        url: "/system1/messages/support/site/connect",
        type: 'GET',
        success: function (result) {
          if(result && result.data){
            let domain = result.data.domain;
            let channel = result.data.channel;
            let enabled = result.data.enabled;
            if(enabled){
              let socket = io(domain, { 'reconnect': true });
              socket.on('connect', function(){
                console.log("建立连接");
                if(me.loginUser.id){
                  socket.emit(channel, {userId:me.loginUser.id});
                }
              });
              socket.on(channel, function(data){
                //弹框提示
                if(data){
                  if(data.notificationType === 'SILENCE'){
                    me.handleSilenceMsg(data);
                  } else {
                    me.$notify({
                      type: data.notificationType.toLowerCase(),
                      title: data.title,
                      message: data.content,
                      duration:data.showTime,
                      showClose: data.sticky,
                      offset:45
                    });
                  }
                }
                me.getUserMessage();
              });
              socket.on('disconnect', function(){
                console.log("关闭连接");
              });

            }
          }
        }
      });
    },
    handleSilenceMsg:function(msg){
      let me = this;
      if(!msg){
        return;
      }
      let content = JSON.parse(msg.content);
      switch (content.option) {
        case 'edbCall-Ring':
        case 'edbCall-Ringing':
        case 'edbCall-Link':
          me.callStartEvent(content.data);
          break;
        case 'edbCall-Hangup':
        case 'edbCall-Unlink':
          me.callEndEvent(content.data);
          break;
        case 'alarm-SOS':
          me.eventId = content.data.eventId;
          me.openEventDialog(me.eventId);
          break;
        default:
          break;
      }

      //运行子页面注册事件
      if(this.silenceEvents && this.silenceEvents[content.option]){
        let events = this.silenceEvents[content.option];
        for(let i in events) {
          if(events[i]){
            events[i](content.data);
          }
        }
      }
    },
    getPlatfromName:function () {
      let me = this;
      getUserPlatfromName()
          .then(result=>{
            if(result.data == null || result.data == ""){
              me.platfromName.platfromName = "适老化平台";
            }else {
              me.platfromName = result.data;
            }

          })
    },
    callStartEvent(data){
      //保存通话记录Id
      localStorage.setItem('callSheetId',data.callSheetId);
      localStorage.setItem('callId',data.callId);
      localStorage.setItem('callNo',data.callNo);

      //弹出坐席首页
      this.openCallingDialog();
    },
    callEndEvent(data){
      this.$confirm('是否清空所有来电信息?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        //移除来电信息
        localStorage.removeItem('callSheetId');
        localStorage.removeItem('callId');
        localStorage.removeItem('callNo');
        this.callingDialog.visible = false;
      });
    },
    registerSilenceEvent(eKey,id,fun){
      if(!this.silenceEvents[eKey]){
        this.silenceEvents[eKey] = {};
      }
      this.silenceEvents[eKey][id] = fun;
    },
    removeSilenceEvent(eKey,id){
      if(this.silenceEvents[eKey] && this.silenceEvents[eKey][id]){
        delete this.silenceEvents[eKey][id];
      }
    },
    getUserMessage:function () {
      let me = this;
      //获取用户未读消息数
      if(me.loginUser.id){
        UserMessage(me.loginUser.id)
            .then(result=>{
              if(result.data !== undefined){
                me.unreadMsg = result.data;
              }
            })
      }
    },
    getinitPermissions:function () {
      let me = this;
      initPermissions()
          .then(result=>{
            let pers = result.data;
            if(pers){
              me.permissions = pers;
            }
          })

    },
    initPermissions:function () {
      let me = this;
      $.get("/system1/user/default/per",function (result) {
        let pers = result.data;
        if(pers){
          me.permissions = pers;
        }
      });
    },
    handleTabSelect:function (tab) {
      this.activeIndex = tab.name;
      this.handleSelect(this.activeIndex);
    },
    handleSelect:function(key,keyPath) {
      let me = this;
      let menuKey = key.split("?")[0];
      gethandleSelect(menuKey)
          .then(result=>{
            let menu = result.data;
            if(menu){
              this.$router.push(menu.path)
            }
          })
    },
    handleJump:function(key,keyPath) {
      let me = this;
      let menuKey = key.split("?")[0];
      $.get("menu/key/"+menuKey,function (result) {
        let menu = result.data;
        if(menu){
          me.$nextTick(function () {
            $("#content-pane").load("page/"+key);
          });
        }
      });
    },
    menuValidate:function (key) {
      return true;
    },
    getMenuMark:function (name, index) {
      if (name) {
        return name.replace(/\s/g, '').substring(0, 1);
      }
      return String(index + 1).padStart(2, '0');
    },
    containKey:function (arrays,key) {
      let flag = false;
      arrays.forEach(function (el) {
        if (el.name === key) {
          flag = true;
        }
      });
      return flag;
    },
    handleMenu:function(){
      this.cancelHideCollapsedFlyout();
      if(this.isCollapse){
        this.isCollapse = false;
        this.collapsedFlyoutMenu = null;
      }else {
        this.isCollapse = true;
      }
    },
    showCollapsedFlyout:function(menu, event){
      if (!menu.children || menu.children.length === 0) {
        this.collapsedFlyoutMenu = null;
        return;
      }
      this.cancelHideCollapsedFlyout();
      this.collapsedFlyoutMenu = menu;
      let rect = event.currentTarget.getBoundingClientRect();
      let top = rect.top;
      let maxTop = window.innerHeight - 420;
      this.collapsedFlyoutTop = Math.max(74, Math.min(top, maxTop > 74 ? maxTop : top));
    },
    scheduleHideCollapsedFlyout:function(){
      this.cancelHideCollapsedFlyout();
      this.collapsedFlyoutTimer = setTimeout(() => {
        this.collapsedFlyoutMenu = null;
      }, 180);
    },
    cancelHideCollapsedFlyout:function(){
      if (this.collapsedFlyoutTimer) {
        clearTimeout(this.collapsedFlyoutTimer);
        this.collapsedFlyoutTimer = null;
      }
    },
    handleCollapsedFlyoutSelect:function(path){
      this.cancelHideCollapsedFlyout();
      this.collapsedFlyoutMenu = null;
      if (!path) {
        return;
      }
      this.$router.push(path).catch(() => {});
    },
    aaa:function(){
      let me = this;
      me.eventDialog1 = true;
    },
    initMinPageHeight:function(){
      this.minPageHeight = $(window).height() - $(".page-main").offset().top;
      this.$store.commit('setMinPageHeight',this.minPageHeight)
    },
    removeTab:function(key) {
      let me = this;
      let tabs = this.tabPanes;
      if(tabs && tabs.length === 1){
        this.$message.warning('请至少保留一个菜单');
        return;
      }
      let activePane = this.activePane;
      if (activePane === key) {
        tabs.forEach(function(tab,index) {
          if (tab.key === key) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activePane = nextTab.key;
              me.handleSelect(activePane);
            }
          }
        });
      }
      this.activePane = activePane;
      this.activeIndex = activePane;
      this.tabPanes = tabs.filter(function (tab) {
        return tab.name !== key;
      });
    },
    initMenuData:function () {
      let me = this;
      initMenuDatanew()
          .then(result=>{
            if(result.data){
              me.menuData = result.data;
              this.$router.push(me.getMenuLink(me.menuData[0]));
            }
          })
    },

    getMenuLink:function(menuItem) {
      let me = this;
      if (menuItem.data.path) {
        return menuItem.data.path;
      } else if (menuItem.children && menuItem.children.length > 0) {
        for (const child of menuItem.children) {
          const childPath = me.getMenuLink(child);
          if (childPath) {
            return childPath;
          }
        }
      }
    },

    logout:function () {
      getLogout().then(result=>{
        if(result) {
          this.$store.commit('CHANGESTORE',false);
          this.$router.push("/");
        }
      })
    },
    handleUserCommand:function (command) {
      let me = this;
      switch (command) {
        case "user-info":
          me.activeIndex = '1000';
          me.handleSelect(me.activeIndex);
          break;
        case "online":
          this.$confirm('请选择接入方式', '提示', {
            distinguishCancelAndClose: true,
            confirmButtonText: '手机',
            cancelButtonText: '话机',
            type: 'warning',
            center:true
          }).then(() => {
          }).catch(action => {
            if(action === 'cancel'){
            }
          });
          break;
        case "outline":
          break;
        case "logout":
          me.$confirm('是否退出登录?', '注销', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            me.logout();
            // 每次调用先断开已有连接，再建立新连接
            if (me.sleepRadarWebSocket) {
              me.sleepRadarWebSocket.onclose = null;  // 阻止旧连接触发重连
              me.sleepRadarWebSocket.close();
              me.sleepRadarWebSocket = null;
            }
          });
          break;
      }
    },
    showBigReport(){
      let me = this;
      showBigReportINDEX()
          .then(result=>{
            me.bigData = result.data;
            let routeData = this.$router.resolve({
                  name:"report_big_screen_"+me.bigData.bigDataName,
                  query:{
                    id:me.bigData.project
                  }
                },
            );
            window.open(routeData.href, '_blank');
          })
    },
    showBigReport1(){
      window.open("http://localhost:8096/call/test")
    },
    tiaoZhuan(){
      let url ='/screen';
      window.open(url,'target','');
    },

    /** 初始化睡眠雷达 WebSocket 连接 */
    initSleepRadarWebSocket(loginUser){
      // The external socket service has no station-token header contract.
      // Do not let a station window fall back to the shared JSESSIONID.
      if (getStationToken()) return;
      let me = this;
      // 每次调用先断开已有连接，再建立新连接
      if (me.sleepRadarWebSocket) {
        me.sleepRadarWebSocket.onclose = null;  // 阻止旧连接触发重连
        me.sleepRadarWebSocket.close();
        me.sleepRadarWebSocket = null;
      }
      const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
      const url = protocol + location.host +'/websocket/sleep-radar';
      console.log('睡眠雷达 WebSocket 连接地址:', url);
      const ws = new WebSocket(url);
      let heartbeatTimer = null;
      ws.onopen = function(){
        console.log('睡眠雷达 WebSocket 连接成功');
        if (loginUser && loginUser.id) {
          const msg = JSON.stringify({
            type: 'sleep-radar',
            userId: loginUser.id,
            topic: 'sleep-radar'
          });
          ws.send(msg);
          console.log('已发送订阅消息:', msg);
        }
        // 每30秒发送心跳，防止服务端超时断开
        heartbeatTimer = setInterval(function(){
          if (ws.readyState === WebSocket.OPEN) {
            ws.send(JSON.stringify({ type: 'ping' }));
          }
        }, 30000);
      };
      ws.onmessage = function(event){
        try {
          const data = JSON.parse(event.data);
          const data2 = JSON.parse(data.data);
          const dataZ = JSON.parse(data2);
          // 心跳响应不需要存储
          if (data.type === 'pong') {
            return;
          }
          // console.log('睡眠雷达data2:', data2);
          // console.log('userId:',loginUser.id);
          // 存储最新推送数据，供子页面或组件使用
          me.sleepRadarData = dataZ;
          if(loginUser.id==dataZ.userId){
            me.eventDialog2=true;
            me.handleSpeak(dataZ.content)
          }
        } catch (e) {
          console.log('睡眠雷达 WebSocket 收到消息(非JSON):', event.data);
        }
      };
      ws.onerror = function(error){
        console.error('睡眠雷达 WebSocket 连接错误:', error);
      };
      ws.onclose = function(event){
        console.log('睡眠雷达 WebSocket 连接关闭, 关闭码:', event.code, '原因:', event.reason || '(无)');
        // 清理心跳定时器
        if (heartbeatTimer) {
          clearInterval(heartbeatTimer);
          heartbeatTimer = null;
        }
        me.sleepRadarWebSocket = null;
        // 3秒后自动重连
        setTimeout(function(){
          if (loginUser && loginUser.id) {
            console.log('睡眠雷达 WebSocket 尝试重连...');
            me.initSleepRadarWebSocket(loginUser);
          }
        }, 3000);
      };
      me.sleepRadarWebSocket = ws;
    },

    getEdbInfo(){
      let me = this;
      EdbInfo()
          .then(result=>{
            if(result.data && result.data){
              me.id = result.data.id;
              me.callStatus = result.data.flag;
              me.seatNo = result.data.seatNo;
              me.seatStatus = result.data.seatStatus;
            } else {
              me.callStatus = '';
              me.seatNo = '';
              me.seatStatus = 'Local';
            }
          })
          .catch()
    },
    checkUnHandleEvent(){
      let me = this;
      getcheckUnHandleEvent()
          .then(result=>{
            if(result.data){
              me.openEventDialog();
            } else {
              me.handleSelect(me.activeIndex);
            }
          })
    },

    openCallingDialog(){
      if((this.activeIndex === '200_100_101' && this.loginUser.type === 'TECHNOLOGY')
          || (this.activeIndex === '200_200_101' && this.loginUser.type === 'SERVICE')){
        return;
      }
      this.callingDialog.visible = true;
      this.$nextTick(()=>{
        if(this.loginUser.type === 'TECHNOLOGY'){
          $('#skill_index_page').load("page/200_100_101?source=index");
        }else if(this.loginUser.type === 'SERVICE'){
          $('#skill_index_page').load("page/200_200_101?source=index");
        }
      })
    },

    openEventDialog(){
      if(this.activeIndex === '300_200'){
        return;
      }
      this.eventDialog.visible = true;
      this.$nextTick(()=>{
        $('#event_index_page').load("page/300_200?source=index");
      })
    }
  }
}
</script>

<style scoped lang="scss">

.head-search > .el-form--inline .el-form-item__content {
  vertical-align: middle;
}

.head-search > .el-form--inline .el-form-item__label {
  color: #ffffff;
}

.alarm-status{
  transform: rotate(45deg);
  width: 50%;
  text-align: center;
  margin-right: -20%;
  font-size: 16px;
  font-weight: bold;
}

.form-line{
  margin-bottom: 0px !important;
}

.layout-shell {
  background: #0f2841;
}

.header{
  height: 82px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 0 24px 0 28px;
  background-repeat:no-repeat;
  background-size: 100% 100%;
  border-width: 0;
  background:
      linear-gradient(135deg, rgba(255, 255, 255, 0.98), rgba(244, 249, 255, 0.96)),
      #ffffff;
  color: #000000;
  margin-top: 10px;
  border-top-left-radius: 28px;
  border-top-right-radius: 28px;
  box-shadow: 0 10px 26px rgba(35, 98, 184, 0.12);
  box-sizing: border-box;
}


.menu11{
  position: relative;
  flex: 0 0 270px;
  width: 270px;
  min-height: 100vh;
  height: 100vh;
  overflow: hidden;
  background:
      linear-gradient(180deg, #12314c 0%, #0f2841 48%, #0b2035 100%),
      #0f2841;
  box-shadow:
      inset -1px 0 0 rgba(255, 255, 255, 0.08),
      14px 0 30px rgba(13, 33, 54, 0.18);
  transition: width 0.2s ease, flex-basis 0.2s ease;
}

.menu11.menu-collapsed {
  flex-basis: 78px;
  width: 78px;
  overflow: hidden;
}

.menu11::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 6px;
  height: 100%;
  background: linear-gradient(180deg, #54d6c5, #4d8cff 46%, #ffd36c);
  opacity: 0.9;
}

.menu11::after {
  content: "";
  position: absolute;
  left: 6px;
  right: 0;
  top: 0;
  height: 96px;
  background: linear-gradient(180deg, rgba(84, 214, 197, 0.16), rgba(84, 214, 197, 0));
  pointer-events: none;
}

.menu-scrollbar {
  position: relative;
  z-index: 1;
  height: 100%;
  padding-top: 62px;
  box-sizing: border-box;
}

.menu-scrollbar /deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
}

.menu-scrollbar /deep/ .el-scrollbar__view {
  min-height: 100%;
}

.menu-toggle {
  position: absolute;
  z-index: 2;
  top: 14px;
  left: 18px;
  width: 42px;
  height: 42px;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
  cursor: pointer;
  font-size: 20px;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.04);
}

.menu-toggle:hover {
  background: rgba(84, 214, 197, 0.18);
}

.el-menu-vertical-demo{
  width: 60px;
}


.el-menu{
  background-color: transparent;
  border-right: 0;
  width: 270px;
  padding: 12px 8px 22px 0;
  font-size: 18px;
  box-sizing: border-box;
}

.menu-collapsed .el-menu {
  width: 78px;
}

.el-menu /deep/ .el-menu,
.el-menu /deep/ .el-submenu,
.el-menu /deep/ .el-submenu__title,
.el-menu /deep/ .el-menu-item {
  background-color: transparent;
}

.el-submenu{
  color: #FFFFFF;
  background-color: transparent !important;
}

.menu-root {
  position: relative;
  --menu-accent: #65d7ff;
}

.menu-tone-0 {
  --menu-accent: #54d6c5;
}

.menu-tone-1 {
  --menu-accent: #7cc7ff;
}

.menu-tone-2 {
  --menu-accent: #ffd36c;
}

.menu-tone-3 {
  --menu-accent: #ff9b8f;
}

.menu-tone-4 {
  --menu-accent: #b7a4ff;
}

.menu-tone-5 {
  --menu-accent: #8de7f2;
}

.el-submenu /deep/ .el-submenu__title {
  height: 54px;
  line-height: 54px;
  margin: 3px 8px 3px 8px;
  padding: 0 12px !important;
  border-left: 3px solid transparent;
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.92) !important;
  font-size: 18px;
  font-weight: 700;
  box-sizing: border-box;
  transition: background 0.18s ease, color 0.18s ease;
}

.el-submenu /deep/ .el-submenu__title .el-submenu__icon-arrow {
  right: 10px;
  margin-top: -6px;
  color: rgba(255, 255, 255, 0.62);
}

.el-submenu/deep/.el-submenu__title:hover{
  background-color: rgba(255, 255, 255, 0.07) !important;
  border-top-right-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
}
.el-submenu.is-opened/deep/>.el-submenu__title{
  border-left-color: var(--menu-accent);
  background-color: rgba(4, 17, 30, 0.36);
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  color: #ffffff !important;
}

.el-menu-item{
  height: 46px;
  line-height: 46px;
  margin: 2px 8px 2px 8px;
  padding: 0 12px !important;
  border-left: 3px solid transparent;
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.78);
  background-color: transparent !important;
  font-size: 16px;
  box-sizing: border-box;
  transition: background 0.18s ease, color 0.18s ease, transform 0.18s ease;
}

.el-menu-item:hover {
  background-color: rgba(255, 255, 255, 0.07) !important;
  color: #ffffff;
}

.el-menu-item.is-active{
  border-left-color: var(--menu-accent);
  background:
      linear-gradient(90deg, rgba(84, 214, 197, 0.26), rgba(255, 255, 255, 0.07)) !important;
  color: #ffffff !important;
  font-weight: 900;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.08);
  transform: none;
}

.menu-leaf.is-active {
  border-left-color: #54d6c5;
}

.menu-mark {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  margin-right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-left: 3px solid var(--menu-accent);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
  font-size: 16px;
  line-height: 34px;
  font-weight: 900;
  box-sizing: border-box;
}

.menu-title,
.branch-title,
.select-label {
  min-width: 0;
  overflow: hidden;
  box-sizing: border-box;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.menu-title {
  font-size: 18px;
  font-weight: 800;
}

.root-title,
.root-single-title,
.branch-title-wrap,
.leaf-title {
  display: flex;
  align-items: center;
  min-width: 0;
}

.root-title {
  width: calc(100% - 22px);
  height: 100%;
}

.branch-title-wrap {
  width: calc(100% - 22px);
  height: 100%;
}

.menu-collapsed .menu-title,
.menu-collapsed .branch-title,
.menu-collapsed .select-label,
.menu-collapsed .branch-line,
.menu-collapsed .leaf-line {
  display: none;
}

.menu-collapsed .menu-branch,
.menu-collapsed .menu-leaf {
  display: none;
}

.menu-collapsed .root-title,
.menu-collapsed .root-single-title {
  width: 100%;
  justify-content: center;
}

.menu-collapsed .menu-mark {
  margin-right: 0;
}

.menu-collapsed .el-submenu /deep/ .el-submenu__title,
.menu-collapsed .el-menu-item {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
  padding-right: 0 !important;
  padding-left: 8px !important;
}

.menu-collapsed .el-submenu /deep/ .el-submenu__title .el-submenu__icon-arrow {
  display: none;
}

.collapsed-menu-list {
  width: 78px;
  padding: 12px 8px 22px 0;
  box-sizing: border-box;
}

.collapsed-menu-root {
  position: relative;
  margin: 3px 8px 3px 8px;
}

.collapsed-root-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  padding: 0;
  border: 0;
  border-left: 3px solid transparent;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  box-sizing: border-box;
}

.collapsed-root-button:hover {
  border-left-color: var(--menu-accent);
  background: rgba(255, 255, 255, 0.07);
}

.collapsed-root-button .menu-mark {
  margin-right: 0;
}

.collapsed-flyout {
  position: fixed;
  left: 78px;
  z-index: 20;
  min-width: 248px;
  max-width: 340px;
  max-height: 72vh;
  padding: 10px;
  overflow: auto;
  border: 1px solid rgba(134, 179, 214, 0.22);
  border-radius: 8px;
  background:
      linear-gradient(180deg, rgba(19, 48, 72, 0.98), rgba(13, 35, 56, 0.98)),
      #102b45;
  box-shadow: 0 18px 38px rgba(7, 20, 34, 0.34);
}

.collapsed-flyout::before {
  content: "";
  position: absolute;
  left: -14px;
  top: 0;
  width: 14px;
  height: 100%;
}

.flyout-title {
  position: sticky;
  top: -10px;
  z-index: 1;
  margin: -10px -10px 8px;
  padding: 12px 14px 11px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(13, 35, 56, 0.98);
  color: #ffffff;
  font-size: 18px;
  line-height: 24px;
  font-weight: 900;
}

.flyout-group {
  margin-top: 6px;
  padding: 6px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.035);
}

.flyout-group-title {
  display: flex;
  align-items: center;
  padding: 5px 8px 7px;
  color: rgba(255, 255, 255, 0.66);
  font-size: 14px;
  line-height: 18px;
  font-weight: 900;
}

.flyout-group-title::before {
  content: "";
  width: 4px;
  height: 14px;
  margin-right: 8px;
  border-radius: 4px;
  background: #54d6c5;
}

.flyout-link {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;
  min-height: 38px;
  padding: 0 10px 0 22px;
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.84);
  font-size: 16px;
  line-height: 20px;
  font-weight: 800;
  text-decoration: none;
  white-space: nowrap;
  text-overflow: ellipsis;
  box-sizing: border-box;
}

.flyout-link::before {
  content: "";
  position: absolute;
  left: 9px;
  top: 50%;
  width: 5px;
  height: 5px;
  margin-top: -2px;
  border-radius: 50%;
  background: rgba(84, 214, 197, 0.7);
}

.flyout-link:hover {
  background: rgba(84, 214, 197, 0.13);
  color: #ffffff;
}

.menu-root-single {
  height: 54px;
  line-height: 54px;
  color: rgba(255, 255, 255, 0.92);
  font-size: 18px;
  font-weight: 700;
}

.menu-root-single.is-active .menu-mark,
.el-submenu.is-opened /deep/ > .el-submenu__title .menu-mark {
  border-color: rgba(255, 255, 255, 0.46);
  border-left-color: var(--menu-accent);
  background: rgba(255, 255, 255, 0.18);
}

.menu-root-single.is-active .menu-mark {
  border-color: rgba(255, 255, 255, 0.46);
  border-left-color: var(--menu-accent);
  background: rgba(255, 255, 255, 0.18);
  color: #ffffff;
}

.menu-branch /deep/ .el-submenu__title {
  height: 42px;
  line-height: 42px;
  margin: 1px 8px 1px 22px;
  padding-left: 10px !important;
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  color: rgba(255, 255, 255, 0.72) !important;
  font-size: 16px;
  font-weight: 700;
}

.branch-line,
.leaf-line {
  flex-shrink: 0;
  display: inline-block;
  box-sizing: border-box;
}

.branch-line {
  width: 12px;
  height: 20px;
  margin-right: 10px;
  border-left: 1px solid rgba(255, 255, 255, 0.26);
  border-bottom: 1px solid rgba(255, 255, 255, 0.26);
  border-radius: 0 0 0 6px;
}

.menu-leaf {
  margin-left: 28px;
  width: auto;
}

.leaf-line {
  width: 14px;
  height: 1px;
  margin-right: 10px;
  background: rgba(255, 255, 255, 0.26);
}

.el-menu-item.is-active .leaf-line {
  height: 3px;
  border-radius: 3px;
  background: #54d6c5;
}

.el-menu-item.is-active .select-label {
  color: #ffffff;
}




.header-logo {
  margin-left: 20px;
  color: #11223E;
  font-family: Source Han Sans CN;
  font-weight: 500;

}

.header-brand {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 16px;
}

.platform-title {
  position: relative;
  display: inline-flex;
  align-items: center;
  min-width: 0;
  color: #1f63df;
  font-size: 29px;
  line-height: 36px;
  font-family: Source Han Sans CN;
  font-weight: 800;
  letter-spacing: 0;
  text-decoration: none;
  white-space: nowrap;
}

.platform-title::before {
  content: "";
  width: 9px;
  height: 34px;
  margin-right: 12px;
  border-radius: 8px;
  background: linear-gradient(180deg, #2c70f7, #26b8a4);
  box-shadow: 0 8px 16px rgba(44, 112, 247, 0.2);
}

.header-date {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 188px;
  height: 52px;
  padding: 0 16px;
  border: 1px solid #dfeaff;
  border-radius: 8px;
  background: linear-gradient(135deg, #f4f8ff, #f8fbff);
  color: #395275;
  font-weight: 700;
  box-sizing: border-box;
}

.header-date span,
.expiration-card span {
  color: #6d7f98;
  font-size: 12px;
  line-height: 16px;
  font-weight: 800;
  white-space: nowrap;
}

.header-date strong,
.expiration-card strong {
  display: block;
  margin-top: 2px;
  color: #10264a;
  font-size: 20px;
  line-height: 24px;
  font-weight: 900;
  letter-spacing: 0;
  white-space: nowrap;
}

.logo{
  width: 64px;
  text-align: center;
  margin-left: 20px;
}

.user-name{
  color: #11223E;
  font-family: '华文楷体';
  font-weight: 500;
  cursor: pointer;
}

.header-actions {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 10px;
}

.big-screen-button {
  width: 52px;
  height: 52px;
  padding: 0;
  border: 1px solid #dce8ff;
  border-radius: 8px;
  background: #ffffff;
  color: #2c70f7;
  cursor: pointer;
  font-size: 20px;
  box-shadow: 0 8px 18px rgba(44, 112, 247, 0.1);
  transition: transform 0.18s ease, border-color 0.18s ease, background 0.18s ease;
}

.big-screen-button:hover {
  transform: translateY(-1px);
  border-color: #2c70f7;
  background: #f5f8ff;
}

.expiration-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 218px;
  height: 52px;
  padding: 0 16px;
  border: 1px solid #dce8ff;
  border-radius: 8px;
  background: linear-gradient(135deg, #f7fbff, #eef8f6);
  box-sizing: border-box;
}

.header-menu{
  display: flex;
  min-width: 0;
  height: 52px;
  padding: 0 12px 0 8px;
  border: 1px solid #dce8ff;
  border-radius: 8px;
  background: #ffffff;
  align-items: center;
  font-size: 15px;
  box-sizing: border-box;
}

.user-avatar {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  margin-right: 9px;
  vertical-align: middle;
  border-radius: 50%;
  object-fit: cover;
  box-shadow: 0 0 0 2px #eef4ff;
}

.user-name{
  display: inline-flex;
  align-items: center;
  max-width: 140px;
  overflow: hidden;
  color: #11223E;
  cursor: pointer;
  font-family: Source Han Sans CN;
  font-weight: 800;
  white-space: nowrap;
  text-overflow: ellipsis;
}

@media (max-width: 1280px) {
  .platform-title {
    font-size: 24px;
    line-height: 32px;
  }

  .header-date {
    display: none;
  }
}

@media (max-width: 980px) {
  .expiration-card {
    display: none;
  }

  .header {
    padding: 0 14px 0 18px;
  }
}

#content-pane {
  -fx-background-color: #eeeeee;
  -fx-text-fill: #292929;
}


.page-main{
  background-color: #E0EBFC;
}

.zego-contains {
  margin: 20px;
  position: relative;
  height: 70vh;
}

.remote-container {
  position: absolute;
  width: 100%;
  height: 70vh;
  z-index: 998;
  background: black;
}

.local-container {
  position: absolute;
  top: 0;
  right: 0;
  width: 30%;
  height: 35vh;
  z-index: 999;
  background-color: #5a5e66;
}

.call-end-btn {
  position: absolute;
  bottom: 30px;
  width: 100px;
  height: 100px;
  margin: 0 47%;
  font-size: 30px;
  z-index: 999;
}
</style>
